export function getDataStateValue(open) {
  return open ? 'open' : 'closed';
}